import React from "react";import './Spinner.css';

const Spinner = ({ color = 'white' }) => {
    return (
        <div className={`spinner ${color}`}>
            {Array.from({ length: 8 }).map((_, i) => (
                <div key={i} className="dot" />
            ))}
        </div>

    );
}
export default Spinner;